/*
 *  Campaign__Create_LocationSelector.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import React from "react";
import FontAwesome from "react-fontawesome";
import ReactTooltip from "react-tooltip";
import logger from "../../../utils/LoggerFrontend";
import { useTranslation } from "react-i18next";

//------------------------------------------------------------------------------
// Interal dep.
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Config
//------------------------------------------------------------------------------
const CITY_PRICE = "+ 200€";
const STATE_PRICE = "+ 400€";
const RADIUS_OPTIONS = ["+ 20km", "+ 30km", "+ 50km", "+ 80km"];
//------------------------------------------------------------------------------
// Components
//------------------------------------------------------------------------------

function SelectedLocationItem(props) {
  const {
    handleChangeRadius,
    index,
    handleRemoveLoc,
    type,
    location,
    radius,
    state,
    country,
    twoLetterCountry = "DE"
  } = props;

  const { t } = useTranslation();

  //handles radius change
  const handleChange = (e) => {
    let value = parseInt(e.target.value, 10);
    handleChangeRadius(value, index);
  };

  //handles removing selected location
  const handleRemove = () => {
    handleRemoveLoc(index);
  };

  const renderMoneyLabel = () => {
    if (index > 1) {
      if (type === "city") {
        return <label className="location-select__money-label">{CITY_PRICE}</label>;
      } else {
        return <label className="location-select__money-label">{STATE_PRICE}</label>;
      }
    }
  };

  const bundesLand = type === "state" && twoLetterCountry === "DE" ? "Bundesland" : state;
  const imageSource = `/images/flagicons/${twoLetterCountry.toString().toLowerCase()}.svg`;

  return (
    <div className="location-select__selected-element">
      <div className="">
        <img className="location-select__flag-icon" src={imageSource} />
      </div>
      {location}
      <select
        className="location-select__radius-select-box"
        defaultValue={type === "city" ? 20 : 80}
        onChange={handleChange}
        value={radius}
      >
        <option value="20">{RADIUS_OPTIONS[0]}</option>
        <option value="30">{RADIUS_OPTIONS[1]}</option>
        <option value="50">{RADIUS_OPTIONS[2]}</option>
        <option value="80">{RADIUS_OPTIONS[3]}</option>
      </select>
      <span className="location-select__remove-button">
        {renderMoneyLabel()}
        <span className="location-select__state-country">
          {bundesLand},<span> </span>
          {country}
        </span>
        <span className="location-select__remove-button-icon">
          <FontAwesome
            name={"times-circle"}
            onClick={handleRemove}
            data-tip={t("Remove location")}
          />
          <ReactTooltip />
        </span>
      </span>
    </div>
  );
}

export default SelectedLocationItem;
